/*
 * お届け時期の表示切り替え（商品ページ）
 * =====================================================================
 * snippets/product-delivery.liquid が全バリエーションぶんを出力しているので、
 * 選択中のサイズのものだけを表示する。
 *
 * Solefia の add-script.js と同じ考え方だが、
 * ⚠️ Solefiaは `[name="id"]` が <select> である前提で change を拾っている。
 *    アメリカンはサイズがボタン（ラジオ）のことがあるので、
 *    **商品フォーム全体の change を拾ってから hidden の [name="id"] を読む**方式にした。
 *    Dawnはバリエーション切り替え時にこの hidden の値を書き換えるので、
 *    どちらの見た目でも動く。
 */
(function () {
  'use strict';

  var wrap = document.querySelector('.deliveryday');
  if (!wrap) return;

  function show(variantId) {
    var found = false;
    wrap.querySelectorAll('.deliveryday-contents').forEach(function (el) {
      var hit = String(el.dataset.variantId) === String(variantId);
      el.classList.toggle('active', hit);
      if (hit) found = true;
    });
    // 万一どれにも当たらなかったときは最初のものを出す（欄が消えるより良い）
    if (!found) {
      var first = wrap.querySelector('.deliveryday-contents');
      if (first) first.classList.add('active');
    }
  }

  function currentVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? input.value : null;
  }

  // Dawnが hidden を書き換えるのを待ってから読む（changeの発火順に依存しないように）
  document.addEventListener('change', function (e) {
    if (!e.target.closest('form[action*="/cart/add"], variant-selects, variant-radios')) return;
    setTimeout(function () {
      var id = currentVariantId();
      if (id) show(id);
    }, 0);
  });

  var initial = currentVariantId();
  if (initial) show(initial);
})();
